import React, {useState} from 'react';

import {labels} from '../../../../../../../util/utils';
import {defaultClientTagColor} from './utils/constants';

import {IconoirTrash} from '@ey-xd/motif-icon';

import Button from '../../../../../../CoreWrappers/Button';
import Input from '../../../../../../CoreWrappers/Input';
import StyledTagsItem from './StyledTagsItem';
import TagsSelect from './TagsSelect';

const TagsItem = ({showErrors, onItemChange, onItemDelete, propTag}) => {
	const [tag, setTag] = useState(propTag);

	const displayColorError = showErrors && (tag?.colorCode === '' || tag?.colorCode === defaultClientTagColor);

	const handlerOnTagNameChange = (e) => {
		const newTag = {...tag, name: e.target.value};
		setTag(newTag);

		if (onItemChange) {
			onItemChange(newTag);
		}
	};

	const handlerOnColorChange = (item) => {
		const newTag = {...tag, colorCode: item.id};
		setTag(newTag);
		onItemChange && onItemChange(newTag);
	};

	const handlerOnDeleteClick = () => {
		if (onItemDelete) {
			onItemDelete(tag);
		}
	};

	const displayTagNameError = showErrors && tag?.name?.trim() === '';

	const renderSelect = () => {
		const props = {
			value: tag?.colorCode,
			onChange: handlerOnColorChange,
			showError: displayColorError
		};

		return <TagsSelect {...props} />;
	};

	const renderInput = () => {
		const props = {
			id: 'tagsTextInputId',
			label: labels.tagName,
			maxLength: 100,
			required: true,
			onChange: handlerOnTagNameChange,
			value: tag?.name,
			clearButtonTitle: labels.clear
		};

		if (displayTagNameError) props.errorMessage = labels.required;

		return <Input {...props} />;
	};

	const renderRemove = () => {
		const props = {
			svg: IconoirTrash,
			title: labels.tagDelete,
			onClick: handlerOnDeleteClick,
			variant: 'ghost',
			iconSize: 20,
			size: 'medium'
		};
		return <Button {...props} />;
	};

	return (
		<StyledTagsItem className={`tags-item-wrapper`}>
			{renderSelect()}
			{renderInput()}
			{renderRemove()}
		</StyledTagsItem>
	);
};

export default TagsItem;
